import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { useTranslation } from "react-i18next/";
import PageTitle from "@components/Common/PageTitle";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { store as userStore } from "@components/VerticalLayout/store";
import { CARD_MENU_LIST } from "./CardMenuList";
import CardMenu from "@helpers/CardMenus";
import { getPathAuthorization } from "@components/VerticalLayout";
import { useSelector } from "react-redux";

export function Sco() {
    const { t } = useTranslation();
    const { oneShop } = useSnapshot(userStore);
    const selectedAccount = useSelector(
        (state: any) => state.global.selectedAccount
    );
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    return (
        <React.Fragment>
            <PageTitle title={"Applications"} />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                className="page-content__clz"
            >
                <StyledBreadcrumb
                    items={[
                        {
                            item: "Settings".toUpperCase(),
                            link: `${process.env.REACT_APP_PORTAIL_URL}`,
                        },
                        {
                            item: selectedAccount?.toUpperCase() || "",
                            link: oneShop
                                ? "/setting/customer-account"
                                : "/compte",
                        },
                        {
                            item: t("Application").toUpperCase(),
                            link: "applications",
                        },
                        {
                            item: t("SCO").toUpperCase(),
                            link: "#",
                        },
                    ]}
                />
                <div className="row p-4">
                    {CARD_MENU_LIST.map((cardMenu: any, index: any) => {
                        if (
                            getPathAuthorization(
                                cardMenu.path,
                                authorizationList
                            ).Visible === true
                        ) {
                            return (
                                <CardMenu
                                    key={index}
                                    title={t(cardMenu.title).toUpperCase()}
                                    number={cardMenu.number}
                                    Icon={cardMenu.Icon}
                                    description={t(cardMenu.description)}
                                    path={cardMenu.path}
                                    numberKiosk="0"
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            </motion.div>
        </React.Fragment>
    );
}
